import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const SIMULATE_ENROLLMENT_QUERY_FIELDNAME = 'simulateEnrollment';
export const SIMULATE_ENROLLMENT_QUERY = registerQuery({
  fieldName: SIMULATE_ENROLLMENT_QUERY_FIELDNAME,
  args: ['flowId', 'objectId'],
  fetcher: ({
    flowId,
    objectId,
    enrollType
  }) => {
    return http.post(`flow-doctor/v3/enrollment-simulation/live-flow/${flowId}/${objectId}/simulate/enroll-type`, {
      data: {
        enrollType
      }
    });
  }
});